import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import sysUtils from 'utils/ShopYourStore';
const { wrapHOC } = FrameworkUtils;
import Location from 'utils/Location';
import LanguageLocale from 'utils/LanguageLocale';
const { getTextFromResource, getLocaleResourceFile } = LanguageLocale;
const getText = getLocaleResourceFile('components/ShopYourStore/ShopMyStoreChiclet/locales', 'ShopMyStoreChiclet');

import ShopMyStoreActions from 'actions/HappeningShopMyStoreActions';

import { userSelector } from 'selectors/user/userSelector';

const localizationSelector = createStructuredSelector({
    shop: getTextFromResource(getText, 'shop'),
    myStore: getTextFromResource(getText, 'myStore')
});

const fields = createSelector(localizationSelector, userSelector, (localization, user) => {
    const isHomepage = Location.isHomepage();
    const shouldRender = isHomepage && sysUtils.shopYourStoreEnabled();
    const hasPreferredStore = !!user.preferredStore;

    return {
        localization,
        hasPreferredStore,
        shouldRender
    };
});

const functions = {
    showStoreSwitcherModal: ShopMyStoreActions.showStoreSwitcherModal
};

const withShopMyStoreChicletProps = wrapHOC(connect(fields, functions));

export {
    fields, withShopMyStoreChicletProps
};
